import React, { useState } from "react";
import Layout from "./layout.js";
import { Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import MetricCard from "../components/MetricCard.js";
import DateInput from "../components/DateInput.js";
import Button from "../components/Button.js";
import Col from "react-bootstrap/Col";
import SearchBar from "../components/Searchbar.js";
import Filter from "../components/Filter";
import SortTable from "../components/SortTable"; // Import SortTable'
import UserIcon from "../assets/svg/users.svg";
import ActivePageIcon from "../assets/svg/activepage.svg";
import ConversionIcon from "../assets/svg/liveconversion.svg";
import ActivePage from "../components/ActivePage.js";
import LiveConversion from "../components/LiveConversion.js";
import ActiveUsers from "../components/ActiveUsers.js";

const SearchEngine = () => {

    const navigate = useNavigate();
    const filterable = true;
    const grid = true;
    const sortable = true;

    const [data, setData] = useState([
        { name: "Campaign 1", clicks: 100 },
        { name: "Campaign 2", clicks: 200 },
        { name: "Campaign 3", clicks: 150 },
    ]);

    const [columns] = useState([
        { label: "Name", accessor: "name" },
        { label: "Clicks", accessor: "clicks" }
    ]);

    const [filteredData, setFilteredData] = useState(data);
    const [searchable] = useState(true); // assuming you want it always true
    const [id] = useState("campaign-table"); // replace with real ID if needed
    const [sortColumn, setSortColumn] = useState("name");
    const [sortOrder, setSortOrder] = useState("asc");

    const handleRefresh = () => {
        window.location.reload(); // This will refresh the page
    };
    const handleViewToggle = () => {
        console.log("View toggled");
    };

    // Handle search query
    const handleSearch = (query) => {
        // Apply search filter on existing data (combined with any existing filter)
        const searchedData = data.filter((item) => {
            return Object.values(item).some((value) =>
                String(value).toLowerCase().includes(query.toLowerCase())
            );
        });
        setFilteredData(searchedData);
    };

    return (
        <Layout>
            <div className="d-flex align-items-center justify-content-between">
                <div className="mt-3 d-flex align-items-center">
                    <div className="d-flex gap-5 md-date">
                        <DateInput label="" type="range" includeTime={false} />
                    </div>

                    {/* Refresh Button */}
                    <div className=" mb-2 ps-3 md-refresh ">
                        <i
                            className="bi bi-arrow-repeat icon-refresh"
                            onClick={handleRefresh}
                        ></i>
                    </div>
                </div>
                <div className="text-right gap-3 ie-btn d-flex">
                    <Button
                        buttonType="^"
                        onClick={() => navigate("/add-usersegment")}
                        label="User Segment"
                    />
                </div>
            </div>

            <div>
                <Row className="align-items-center  mt-4">
                    <Col>
                        {searchable && (
                            <SearchBar
                                tableId={id}
                                gridviewId={id}
                                placeholder="Search for data..."
                                onSearch={(query) => handleSearch(query)}
                            />
                        )}
                    </Col>
                    <Col className="mt-2 col-auto">
                        <div className="d-flex justify-content-end gap-2">
                            {filterable && (
                                <Filter
                                    columns={columns}
                                    data={data}
                                    onFilter={setFilteredData} // Update filtered data
                                    tableId={id}
                                    gridviewId={id}
                                />
                            )}

                            {/* View Toggle Button */}
                            {grid && (
                                <div className="table-btn">
                                    <button className="btn grid-btn " onClick={handleViewToggle}>
                                        <i className="bi bi-grid"></i>
                                    </button>
                                </div>
                            )}

                            {sortable && (
                                <SortTable
                                    data={filteredData}
                                    setSortedData={setFilteredData}
                                    columns={columns}
                                    sortColumn={sortColumn}
                                    setSortColumn={setSortColumn}
                                    sortOrder={sortOrder}
                                    setSortOrder={setSortOrder}
                                />
                            )}
                        </div>
                    </Col>
                </Row>
            </div>

            <div className="card-container gap-4 flex-wrap">
                <Row className="metrix-container">
                    <Col xs={4} md={3}>
                        <MetricCard
                            title="Active Users"
                            operation="count"
                            column="col1"
                            icon={UserIcon} // You can change this to any Bootstrap icon name like "check-circle", "database", etc.
                            tooltipText="This shows the count of live blogs" // Tooltip for additional context
                        />
                    </Col>
                    <Col xs={4} md={3}>
                        <MetricCard
                            title="Active Pages"
                            operation="count"
                            column="col2"
                            icon={ActivePageIcon}// You can change this to any Bootstrap icon name like "check-circle", "database", etc.
                            tooltipText="This shows the count of Draft Blog" // Tooltip for additional context
                        />
                    </Col>
                    <Col xs={4} md={3}>
                        <MetricCard
                            title="Conversion"
                            operation="total"
                            column="col3"
                            icon={ConversionIcon} // You can change this to any Bootstrap icon name like "check-circle", "database", etc.
                            tooltipText="This shows the total of Views" // Tooltip for additional context
                        />
                    </Col>
                </Row>
            </div>

            <div>
                <Row>
                    <Col md={7}>
                        <div style={{ background: "#fff", padding: "20px", borderRadius: "12px", marginTop: "20px" }}>
                            <h3>Active Pages</h3>
                            <ActivePage />
                        </div>
                    </Col>

                    <Col md={5}>
                        <div style={{ background: "#fff", padding: "20px", borderRadius: "12px", marginTop: "20px" }}>
                            <h3>Live Conversion</h3>
                            <LiveConversion />
                        </div>
                    </Col>
                </Row>
            </div>

            <div>
                <Row>
                    <Col md={7}>
                        <div style={{ background: "#fff", padding: "20px", borderRadius: "12px", marginTop: "20px" }}>
                            <h3>Active Users</h3>
                            <ActiveUsers/>
                        </div>
                    </Col>
                </Row>
            </div>
        </Layout>
    )
}

export default SearchEngine;